import routes from "../../../engine/routes";
import React from "react";
import { useLocation, useParams } from "react-router-dom";
import { RenderMenuSider } from "../../../engine/AuthRoute/navigationHelper";
import { useSelector } from "react-redux";

export const InstitutionSlider = () => {
  const location = useLocation();

  const { id } = useParams();

  const { institution, loading } = useSelector(state => state.institution);

  const prestationDetailMenu = {
    title: id === "new" ? "Nouvelle institution" : institution.name,
    root: routes.institutions,
    children: [
      routes.institutions(id).detail,
      routes.institutions(id).detailUsers,
      routes.institutions(id).addresses,
      routes.institutions(id).locations,
      routes.institutions(id).responsables,
    ],
  };

  return <RenderMenuSider menu={prestationDetailMenu} />;
};
